import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  selectIsGroupOrderCurrentDinerAdmin,
  selectCartIsGroupOrder,
  selectCurentDinerAmountSpent,
  getTotalCartItemQuantities
} from 'bento-ordering/cart/selectors';
import MobileFooter from 'bento-ordering/base/components/MobileFooter';
import ViewCart from 'bento-ordering/menus/components/ViewCart';
import { accountHasInvestorDayFeatureFlag } from 'bento-ordering/utils/featureFlags/hasInvestorDayFeatureFlag';

class MenuPageFooter extends React.Component {
  static propTypes = {
    quantity: PropTypes.number,
    isGroupOrder: PropTypes.bool,
    isGroupOrderAdmin: PropTypes.bool,
    amountSpent: PropTypes.number,
    subtotal: PropTypes.number,
    onClick: PropTypes.func,
    to: PropTypes.string,
    hasInvestorDayFeature: PropTypes.bool
  };

  render() {
    if (this.props.quantity === 0) {
      return null;
    }

    const {
      isGroupOrder,
      isGroupOrderAdmin,
      amountSpent,
      subtotal,
      quantity,
      onClick,
      to,
      hasInvestorDayFeature
    } = this.props;

    const displayAmountSpentByDiner = isGroupOrder && !isGroupOrderAdmin;
    const total = displayAmountSpentByDiner ? amountSpent : subtotal;
    return (
      <MobileFooter>
        <ViewCart
          subtotal={total}
          quantity={quantity}
          onClick={onClick}
          to={to}
          hasInvestorDayFeature={hasInvestorDayFeature}
        />
      </MobileFooter>
    );
  }
}

const mapStateToProps = state => {
  return {
    subtotal: state.cart.subtotal,
    quantity: getTotalCartItemQuantities(state.cart),
    isGroupOrder: selectCartIsGroupOrder(state),
    isGroupOrderAdmin: selectIsGroupOrderCurrentDinerAdmin(state),
    amountSpent: selectCurentDinerAmountSpent(state),
    form: state.form,
    menuItem: state.menuItem,
    hasInvestorDayFeature: accountHasInvestorDayFeatureFlag(state.account)
  };
};

export default withRouter(connect(mapStateToProps)(MenuPageFooter));
